import * as ambassadorWixEcomV1AbandonedCheckout from './ecom-v1-abandoned-checkout-abandoned-checkouts.http.js';
import * as ambassadorWixEcomV1AbandonedCheckoutTypes from './ecom-v1-abandoned-checkout-abandoned-checkouts.types.js';
import * as ambassadorWixEcomV1AbandonedCheckoutUniversalTypes from './ecom-v1-abandoned-checkout-abandoned-checkouts.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function getAbandonedCheckout(): __PublicMethodMetaInfo<
  'GET',
  { abandonedCheckoutId: string },
  ambassadorWixEcomV1AbandonedCheckoutUniversalTypes.GetAbandonedCheckoutRequest,
  ambassadorWixEcomV1AbandonedCheckoutTypes.GetAbandonedCheckoutRequest,
  ambassadorWixEcomV1AbandonedCheckoutUniversalTypes.GetAbandonedCheckoutResponse,
  ambassadorWixEcomV1AbandonedCheckoutTypes.GetAbandonedCheckoutResponse
> {
  const payload = { abandonedCheckoutId: ':abandonedCheckoutId' } as any;

  const getRequestOptions =
    ambassadorWixEcomV1AbandonedCheckout.getAbandonedCheckout(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/abandoned-checkout/{abandonedCheckoutId}',
    pathParams: { abandonedCheckoutId: 'abandonedCheckoutId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteAbandonedCheckout(): __PublicMethodMetaInfo<
  'DELETE',
  { abandonedCheckoutId: string },
  ambassadorWixEcomV1AbandonedCheckoutUniversalTypes.DeleteAbandonedCheckoutRequest,
  ambassadorWixEcomV1AbandonedCheckoutTypes.DeleteAbandonedCheckoutRequest,
  ambassadorWixEcomV1AbandonedCheckoutUniversalTypes.DeleteAbandonedCheckoutResponse,
  ambassadorWixEcomV1AbandonedCheckoutTypes.DeleteAbandonedCheckoutResponse
> {
  const payload = { abandonedCheckoutId: ':abandonedCheckoutId' } as any;

  const getRequestOptions =
    ambassadorWixEcomV1AbandonedCheckout.deleteAbandonedCheckout(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/abandoned-checkout/{abandonedCheckoutId}',
    pathParams: { abandonedCheckoutId: 'abandonedCheckoutId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkDeleteAbandonedCheckouts(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEcomV1AbandonedCheckoutUniversalTypes.BulkDeleteAbandonedCheckoutsRequest,
  ambassadorWixEcomV1AbandonedCheckoutTypes.BulkDeleteAbandonedCheckoutsRequest,
  ambassadorWixEcomV1AbandonedCheckoutUniversalTypes.BulkDeleteAbandonedCheckoutsResponse,
  ambassadorWixEcomV1AbandonedCheckoutTypes.BulkDeleteAbandonedCheckoutsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1AbandonedCheckout.bulkDeleteAbandonedCheckouts(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/abandoned-checkout/delete',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryAbandonedCheckouts(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEcomV1AbandonedCheckoutUniversalTypes.QueryAbandonedCheckoutsRequest,
  ambassadorWixEcomV1AbandonedCheckoutTypes.QueryAbandonedCheckoutsRequest,
  ambassadorWixEcomV1AbandonedCheckoutUniversalTypes.QueryAbandonedCheckoutsResponse,
  ambassadorWixEcomV1AbandonedCheckoutTypes.QueryAbandonedCheckoutsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1AbandonedCheckout.queryAbandonedCheckouts(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/abandoned-checkout/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function searchAbandonedCheckouts(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEcomV1AbandonedCheckoutUniversalTypes.SearchAbandonedCheckoutsRequest,
  ambassadorWixEcomV1AbandonedCheckoutTypes.SearchAbandonedCheckoutsRequest,
  ambassadorWixEcomV1AbandonedCheckoutUniversalTypes.SearchAbandonedCheckoutsResponse,
  ambassadorWixEcomV1AbandonedCheckoutTypes.SearchAbandonedCheckoutsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1AbandonedCheckout.searchAbandonedCheckouts(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/abandoned-checkout/search',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function addAbandonedCheckoutActivity(): __PublicMethodMetaInfo<
  'POST',
  { abandonedCheckoutId: string },
  ambassadorWixEcomV1AbandonedCheckoutUniversalTypes.AddAbandonedCheckoutActivityRequest,
  ambassadorWixEcomV1AbandonedCheckoutTypes.AddAbandonedCheckoutActivityRequest,
  ambassadorWixEcomV1AbandonedCheckoutUniversalTypes.AddAbandonedCheckoutActivityResponse,
  ambassadorWixEcomV1AbandonedCheckoutTypes.AddAbandonedCheckoutActivityResponse
> {
  const payload = { abandonedCheckoutId: ':abandonedCheckoutId' } as any;

  const getRequestOptions =
    ambassadorWixEcomV1AbandonedCheckout.addAbandonedCheckoutActivity(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/abandoned-checkouts/{abandonedCheckoutId}/add-activity',
    pathParams: { abandonedCheckoutId: 'abandonedCheckoutId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getAbandonedCheckoutAnalytics(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEcomV1AbandonedCheckoutUniversalTypes.GetAbandonedCheckoutAnalyticsRequest,
  ambassadorWixEcomV1AbandonedCheckoutTypes.GetAbandonedCheckoutAnalyticsRequest,
  ambassadorWixEcomV1AbandonedCheckoutUniversalTypes.GetAbandonedCheckoutAnalyticsResponse,
  ambassadorWixEcomV1AbandonedCheckoutTypes.GetAbandonedCheckoutAnalyticsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1AbandonedCheckout.getAbandonedCheckoutAnalytics(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/abandoned-checkout/get-analytics',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function redirectToCheckout(): __PublicMethodMetaInfo<
  'GET',
  { abandonedCheckoutId: string },
  ambassadorWixEcomV1AbandonedCheckoutUniversalTypes.RedirectToCheckoutRequest,
  ambassadorWixEcomV1AbandonedCheckoutTypes.RedirectToCheckoutRequest,
  ambassadorWixEcomV1AbandonedCheckoutUniversalTypes.RawHttpResponse,
  ambassadorWixEcomV1AbandonedCheckoutTypes.RawHttpResponse
> {
  const payload = { abandonedCheckoutId: ':abandonedCheckoutId' } as any;

  const getRequestOptions =
    ambassadorWixEcomV1AbandonedCheckout.redirectToCheckout(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/abandoned-checkout/{abandonedCheckoutId}/redirect-to-checkout',
    pathParams: { abandonedCheckoutId: 'abandonedCheckoutId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  AbandonedCheckout as AbandonedCheckoutOriginal,
  ActivityType as ActivityTypeOriginal,
  ActivityTypeWithLiterals as ActivityTypeWithLiteralsOriginal,
  Status as StatusOriginal,
  StatusWithLiterals as StatusWithLiteralsOriginal,
  V1BuyerInfo as V1BuyerInfoOriginal,
  V1BuyerInfoIdOneOf as V1BuyerInfoIdOneOfOriginal,
  FullAddressContactDetails as FullAddressContactDetailsOriginal,
  VatId as VatIdOriginal,
  VatType as VatTypeOriginal,
  VatTypeWithLiterals as VatTypeWithLiteralsOriginal,
  MultiCurrencyPrice as MultiCurrencyPriceOriginal,
  Activity as ActivityOriginal,
  LineItem as LineItemOriginal,
  CatalogReference as CatalogReferenceOriginal,
  ProductName as ProductNameOriginal,
  DescriptionLine as DescriptionLineOriginal,
  DescriptionLineValueOneOf as DescriptionLineValueOneOfOriginal,
  DescriptionLineDescriptionLineValueOneOf as DescriptionLineDescriptionLineValueOneOfOriginal,
  DescriptionLineName as DescriptionLineNameOriginal,
  PlainTextValue as PlainTextValueOriginal,
  Color as ColorOriginal,
  DescriptionLineType as DescriptionLineTypeOriginal,
  DescriptionLineTypeWithLiterals as DescriptionLineTypeWithLiteralsOriginal,
  Image as ImageOriginal,
  PhysicalProperties as PhysicalPropertiesOriginal,
  Dimensions as DimensionsOriginal,
  DimensionsUnit as DimensionsUnitOriginal,
  DimensionsUnitWithLiterals as DimensionsUnitWithLiteralsOriginal,
  AppliedDiscount as AppliedDiscountOriginal,
  AppliedDiscountDiscountSourceOneOf as AppliedDiscountDiscountSourceOneOfOriginal,
  DiscountType as DiscountTypeOriginal,
  DiscountTypeWithLiterals as DiscountTypeWithLiteralsOriginal,
  Coupon as CouponOriginal,
  MerchantDiscount as MerchantDiscountOriginal,
  DiscountRule as DiscountRuleOriginal,
  DiscountRuleName as DiscountRuleNameOriginal,
  CartAbandonedEvent as CartAbandonedEventOriginal,
  BuyerInfo as BuyerInfoOriginal,
  Identity as IdentityOriginal,
  IdentityWithLiterals as IdentityWithLiteralsOriginal,
  Totals as TotalsOriginal,
  CartRecoveredEvent as CartRecoveredEventOriginal,
  AbandonedCheckoutRecovered as AbandonedCheckoutRecoveredOriginal,
  GetAbandonedCheckoutRequest as GetAbandonedCheckoutRequestOriginal,
  GetAbandonedCheckoutResponse as GetAbandonedCheckoutResponseOriginal,
  DeleteAbandonedCheckoutRequest as DeleteAbandonedCheckoutRequestOriginal,
  DeleteAbandonedCheckoutResponse as DeleteAbandonedCheckoutResponseOriginal,
  BulkDeleteAbandonedCheckoutsRequest as BulkDeleteAbandonedCheckoutsRequestOriginal,
  BulkDeleteAbandonedCheckoutsResponse as BulkDeleteAbandonedCheckoutsResponseOriginal,
  ItemMetadata as ItemMetadataOriginal,
  ApplicationError as ApplicationErrorOriginal,
  BulkAbandonedCheckoutResult as BulkAbandonedCheckoutResultOriginal,
  BulkActionMetadata as BulkActionMetadataOriginal,
  QueryAbandonedCheckoutsRequest as QueryAbandonedCheckoutsRequestOriginal,
  QueryV2 as QueryV2Original,
  QueryV2PagingMethodOneOf as QueryV2PagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  AddressLocation as AddressLocationOriginal,
  Paging as PagingOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryAbandonedCheckoutsResponse as QueryAbandonedCheckoutsResponseOriginal,
  PagingMetadataV2 as PagingMetadataV2Original,
  Cursors as CursorsOriginal,
  SearchAbandonedCheckoutsRequest as SearchAbandonedCheckoutsRequestOriginal,
  Search as SearchOriginal,
  SearchPagingMethodOneOf as SearchPagingMethodOneOfOriginal,
  CommonSorting as CommonSortingOriginal,
  CommonSortOrder as CommonSortOrderOriginal,
  CommonSortOrderWithLiterals as CommonSortOrderWithLiteralsOriginal,
  SearchDetails as SearchDetailsOriginal,
  Mode as ModeOriginal,
  ModeWithLiterals as ModeWithLiteralsOriginal,
  CommonPaging as CommonPagingOriginal,
  CommonCursorPaging as CommonCursorPagingOriginal,
  SearchAbandonedCheckoutsResponse as SearchAbandonedCheckoutsResponseOriginal,
  CommonPagingMetadataV2 as CommonPagingMetadataV2Original,
  CommonCursors as CommonCursorsOriginal,
  AddAbandonedCheckoutActivityRequest as AddAbandonedCheckoutActivityRequestOriginal,
  AddAbandonedCheckoutActivityResponse as AddAbandonedCheckoutActivityResponseOriginal,
  GetAbandonedCheckoutAnalyticsRequest as GetAbandonedCheckoutAnalyticsRequestOriginal,
  Metric as MetricOriginal,
  MetricWithLiterals as MetricWithLiteralsOriginal,
  GetAbandonedCheckoutAnalyticsResponse as GetAbandonedCheckoutAnalyticsResponseOriginal,
  Task as TaskOriginal,
  TaskKey as TaskKeyOriginal,
  TaskAction as TaskActionOriginal,
  TaskActionActionOneOf as TaskActionActionOneOfOriginal,
  Complete as CompleteOriginal,
  Cancel as CancelOriginal,
  Reschedule as RescheduleOriginal,
  RedirectToCheckoutRequest as RedirectToCheckoutRequestOriginal,
  RawHttpResponse as RawHttpResponseOriginal,
  HeadersEntry as HeadersEntryOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  Empty as EmptyOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
} from './ecom-v1-abandoned-checkout-abandoned-checkouts.types.js';
